/* eslint-disable */

import React, { useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { Box } from "@mui/material";

import { CommentDTO, getCommentsByEstimateId } from "api";
import { useNotify } from "hooks";
import { getLoggedUserData } from "utils";
import { CommentTextField, CommonComment, Label14SemiBold, Loading } from "components";

import { EstimateCommentsProps } from "./types";

export const EstimateComments = ({ siteId, estimateId, setCommentsTitle }: EstimateCommentsProps) => {
  const notify = useNotify();
  const { id: userId, email } = getLoggedUserData();
  const { data: comments, isError, isLoading, mutateAsync: commentsByEstimateId } = useMutation(getCommentsByEstimateId);

  const handleSuccessfulSubmit = () => {
    commentsByEstimateId(estimateId)
      .then(() => notify.success("Comment was successfully added!"))
      .catch(() => notify.error("Failed to fetch comments"));
  };

  useEffect(() => {
    commentsByEstimateId(estimateId);
  }, [estimateId, commentsByEstimateId]);

  useEffect(() => {
    if (comments?.length) {
      setCommentsTitle(`Comments (${comments?.length})`);
    }
  }, [comments, setCommentsTitle]);

  return (
    isLoading ? (
      <Loading sx={{
        mt: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }} />
    ) : (
      <Box
        sx={{
          backgroundColor: "background.default",
          p: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {isError ? (
            <Label14SemiBold sx={{ m: 2 }}>
              Failed to fetch comments
            </Label14SemiBold>
          ) : !comments?.length ? (
            <Label14SemiBold sx={{ m: 2 }}>
              No comments
            </Label14SemiBold>
          ) : (comments?.map((comment: CommentDTO) => (
            <Box
              key={comment.id}
              id={`${comment.id}`}
              sx={{
                width: "100%",
                alignSelf:
                  comment.authorEmail === email
                    ? "flex-end"
                    : "flex-start",
              }}
            >
              <CommonComment
                siteId={siteId}
                estimateId={estimateId}
                comment={comment}
                currentUserId={userId}
                onSuccessfulSiteSubmit={handleSuccessfulSubmit}
              />
            </Box>
          )))}
        </Box>
        <Box sx={{ mt: 1 }}>
          <CommentTextField
            id={estimateId}
            siteId={siteId}
            isEstimate
            onSuccessfulSubmit={handleSuccessfulSubmit}
          />
        </Box>
      </Box>
    )
  )
};
